var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-link',{staticClass:"text-decoration-none text-white footer-link",attrs:{"href":_vm.href}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }